import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";

import TSListPay from "components/Forms/TSListPay.js";
import TSBooking from "components/Forms/TSBooking.js";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

//function Visit() {
const Visit = (props) => {
    const ServiceType = (props.match.params.ServiceType !== undefined) ? props.match.params.ServiceType : null;

    const [pills, setPills] = useState("2");
    const [teleItem, setTeleItem] = useState(null);
    useEffect(() => {
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    });
    const liffId = { confirm: '1654063801-JpnXVx2a', tele: '1654063801-PwXBy90W', profile: '1654063801-mPYn4Dba', visit: '1654063801-JAvgrW63', visitBooking: '1654063801-5QXvb928' }
    const liff = window.liff;

    liff.init({
        liffId: (ServiceType == 'booking') ? liffId.visitBooking : liffId.visit
    })
        .then(() => {

            if (liff.isLoggedIn()) {
                liff.getProfile().then(function (profile) {
                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                if (user.isActive == 1) {
                                    /*
                                    var host = '/payment/'
                                    const queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
                                    const params = new URLSearchParams(queryString);
                                    const id = params.get('id');

                                    if (id != null && id != '') {
                                        window.location.assign(host + id);
                                    } else {
                                        window.location.assign("https://developers.line.biz");
                                    }
                                    */
                                }
                                else {
                                    const { from } = props.location.state || { from: { pathname: "/profile/" + liffId.tele } };
                                    props.history.push(from);
                                }

                            },
                            error => {
                                const { from } = props.location.state || { from: { pathname: "/lineregister" } };
                                props.history.push(from);
                            }
                        );

                }).catch(function (error) {
                    //window.alert('Error getting profile: ' + error);
                });
            }
            else {
                /*
                var host = '/payment/'
                const queryString = decodeURIComponent(window.location.search).replace("?liff.state=", "");
                const params = new URLSearchParams(queryString);
                const id = params.get('id');

                if (id != null && id != '') {
                    window.location.assign(host + id);
                } else {
                    window.location.assign("https://developers.line.biz");
                }
                */
            }

        })
        .catch((err) => {

        });

    //const currentUser = authenticationService.currentUserValue;
    //if (!currentUser) {
    //    return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    //}

    return (
        <>
            <div className="wrapper">
                <div className="section" style={{ padding: 0 }}>
                    <Container>
                        <h3 className="title" style={{
                            fontSize: '1.2em', backgroundColor: '#f2f2f2'
                        }}>{(ServiceType == 'booking') ? "รายการนัดออนไลน์" : "รายการปรึกษาและรับยาต่อเนื่อง"}</h3>
                        {(ServiceType == 'booking') ? <TSBooking /> : <TSListPay />}
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default Visit;
